let cache = {}
let detailedCache = {}

export default class CourseService {
  constructor(svc) {
    this.svc = svc
  }

  async getCoursesBy(location, languageCourse, reload = false) {
    if ((location in cache) && !reload) return this.getCachedLocation(location, languageCourse)
    try {
      let res = await this.svc.getCoursesBy(location, languageCourse)
      cache[location] = res
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getCoursesDetailedBy(location, languageCourse) {
    try {
      let res = await this.svc.getCoursesDetailedBy(location, languageCourse)
      detailedCache[location] = res
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  getCachedLocation(location) {
    return cache[location]
  }
}
